(() => {
  if (window.memeCookiePreferencesReady) return;
  window.memeCookiePreferencesReady = true;
  document.addEventListener('click', async event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-cookie-preferences]');
    if (!button || button.disabled) return;
    const error = button.closest('[data-cookie-controls]')?.querySelector('[data-privacy-error]');
    if (error) error.hidden = true;
    button.disabled = true;
    try {
      if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('Consent settings unavailable');
      await window.privacyBanner.showPreferences();
    } catch (_) {
      if (error) error.hidden = false;
    } finally {
      button.disabled = false;
    }
  });
})();
